import moment from 'moment';

const showAsExpired = bannerSet => {
  return Boolean(bannerSet.validity && moment(bannerSet.validity).isBefore(moment()));
};

export default showAsExpired;
